import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const griefToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.GRIEF,
  iFrameSrcUrl: '/grief',
  micrositeUrl: 'grief',
  title: {
    id: 'grief.title',
    defaultMessage: 'Finding your way through grief',
    description: 'Microsite page title',
  },
  featureFlag: 'isGriefToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/coping-with-grief',
      },
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
  ],
  page: '202509 grief',
  trackUTMParams: {
    utm_campaign: 'grief202509',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'grief',
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: true,
}
